export async function copyToClipboard(text: string): Promise<boolean> {
  if (!text) return false

  try {
    // Try modern clipboard API first
    if (navigator?.clipboard) {
      await navigator.clipboard.writeText(text)
      return true
    }

    // Fallback for older browsers
    const textArea = document.createElement('textarea')
    textArea.value = text

    Object.assign(textArea.style, {
      position: 'fixed',
      top: 0,
      left: 0,
      opacity: 0,
    })

    document.body.appendChild(textArea)
    textArea.focus()
    textArea.select()

    try {
      const successful = document.execCommand('copy')
      if (!successful) throw new Error('Copy command failed')
      return true
    } catch (err) {
      console.error('Fallback copy failed:', err)
      return false
    } finally {
      document.body.removeChild(textArea)
    }
  } catch (error) {
    console.error('Copy failed:', error)
    return false
  }
}
